import {capitalize} from 'lodash';

export enum ContentLabPlanBundle {
  FREE = 'Free',
  STUDIO = 'Studio' /* DEPRECATED, use STARTER instead */,
  BUSINESS = 'Business' /* DEPRECATED, use PRO instead */,
  ENTERPRISE = 'Enterprise',
  PRO = 'Pro',
  STARTER = 'Starter',
  TRIAL = 'Trial',
}

export const BUNDLE_TO_VARIANT: Record<string, ContentLabPlanBundle> =
  Object.values(ContentLabPlanBundle).reduce(
    (acc: Record<string, ContentLabPlanBundle>, value) => {
      const variant = value as ContentLabPlanBundle;
      acc[value.toLowerCase()] = variant;
      acc[value.toUpperCase()] = variant;
      acc[capitalize(value)] = variant;
      return acc;
    },
    {}
  );

export default ContentLabPlanBundle;
